/* eslint-disable no-console */
import React, { useEffect } from 'react';
import App from 'next/app';
import { ThemeProvider } from 'styled-components';
import dynamic from 'next/dynamic';
import Head from 'next/head';
import baseTheme from '@greatmindsorg/atomic-ui-lib-lts/dist/themes/baseTheme';
import { Toast } from '~/components/atoms/Toast/Toast.component';
import '@greatmindsorg/icominds-lib/dist/css/style.css';

import { ToastProvider } from '~/lib/hooks/useToast';
import { CreateInterceptors } from '~/components/utility/CreateInterceptors';
import { initializeAnalytics } from '~/components/utility/initializeAnalytics';
import { getPayloadCookie } from '~/components/utility/getPayloadCookie';
import { RootStoreContext, useRootStore } from '../stores/RootStore';
import '@greatmindsorg/gmui-lib/dist/global.css';

const interceptors = CreateInterceptors.getInstance();
interceptors.registerInterceptors();

React.useLayoutEffect = React.useEffect;

const Amplify = dynamic(() => import('../components/utility/AmplifyDynamicImport'), { ssr: false });
const GlobalStyle = dynamic(() => import('../components/utility/GlobalStyle'), { ssr: false });
const DynamicPendoInitializer = dynamic(
  () => import('../components/atoms/PendoInitializer/PendoInitializer.component'),
  { ssr: false },
);

function LoginApp({ Component, pageProps }) {
  const rootStore = useRootStore();

  useEffect(() => {
    initializeAnalytics();
  }, []);

  return (
    <>
      <Head>
        <link
          rel="icon"
          href="https://cdn.digital.greatminds.org/dp-assets/dp-images/GM_favicon.ico"
        />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </Head>
      <ThemeProvider theme={baseTheme}>
        <RootStoreContext.Provider value={rootStore}>
          <Amplify />
          <GlobalStyle isWebView={pageProps.isWebView} />
          <ToastProvider>
            <Toast />
            <DynamicPendoInitializer />
            <Component {...pageProps} />
          </ToastProvider>
        </RootStoreContext.Provider>
      </ThemeProvider>
    </>
  );
}

LoginApp.getInitialProps = async appContext => {
  const appProps = await App.getInitialProps(appContext);
  let cookie = null;
  let isWebView = false;
  if (appContext.ctx.req) {
    cookie = appContext.ctx.req.headers.cookie;
    isWebView =
      appContext?.ctx?.req?.headers['x-platform'] === 'mobile' &&
      appContext?.ctx?.req?.headers['app-name'] === 'greatmindsMobile';
  }
  const cookiePayload = getPayloadCookie('user', cookie);
  appProps.pageProps = {
    ...appProps.pageProps,
    isLoggedIn: !!cookiePayload,
    cookie,
    isWebView,
  };
  return { ...appProps };
};

export default LoginApp;
